export default __webpack_public_path__ + "f4b39d082a82ff234a2d8baf5da26018.png";